/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { setMaxHeightByQuery } from "src/libs/utilities"
import { ALIGN, ICard } from "src/modules/pe-landing-module/data/interfaces"
import { getCssDemention } from "src/libs/utilities/getCssDemention"
import { useComposition } from "src/modules/pe-landing-module/hooks/useComposition"
import "../../../../assets/css/cards.scss"
import { ICardsProps } from "../Cards"
import { useSyncState } from "src/modules/pe-basic-module/hooks/useSyncState"
import Card from "./Card"
import HAccordeonCard from "./HAccordeonCard"
import DataContentEditor from "../../landing-edit/editors/data-content-editor"
import getTypographyStyle from "../../../utils/getTypographyStyle"

/* Protopia Ecosystem component */
const CardHaccordeon = ({data, ...props}: ICardsProps): JSX.Element => {
    const composition       = useComposition(props.section)
    const current           = useSyncState( 0 )
    const [marginLeft]      = useState<string>(!![ALIGN.END, ALIGN.MIDDLE ].find(e => e === data.horizontal_align)    || !data.horizontal_align ? "auto" : "0")
    const [marginRight]     = useState<string>(!![ALIGN.START, ALIGN.MIDDLE ].find(e => e === data.horizontal_align)  || !data.horizontal_align ? "auto" : "0")
    const [marginTop]       = useState<string>(!![ALIGN.END, ALIGN.MIDDLE ].find(e => e === data.vertical_align)      || !data.vertical_align   ? "auto" : "0")
    const [marginBottom]    = useState<string>(!![ALIGN.START, ALIGN.MIDDLE ].find(e => e === data.vertical_align)    || !data.vertical_align   ? "auto" : "0")
    const [width]           = useState<string>(getCssDemention( data.width, "100%" ))
    const [height, ]        = useState<string>(getCssDemention( data.height, "fit-content" ))
    const alignFields = () => {
        data.card_fields.forEach((field, i) => {
            setMaxHeightByQuery( `.landing-cards-${props.section.id} [data-card-field-id="${i}"]` );
            setMaxHeightByQuery( `.landing-cards-${props.section.id} [data-card-field-id="${i}"] .speech-bubble-content`);
        })
        
    }
    useEffect(() => {
        addCSSClass(
            `landing-cards-${props.section.id}`,
            `.landing-cards-${props.section.id} {
                margin-left: ${marginLeft};
                margin-right: ${marginRight};
                margin-top: ${marginTop};
                margin-bottom: ${marginBottom};
                max-width: ${ width };
                max-height: ${ height };
                width: ${ width };
                height: ${ height };
                display: flex;
                width: 100%;
                flex-wrap: nowrap;
                z-index:1;                
                .my-title {
                    ${getTypographyStyle( data.cardTitleTypography )}
                }
            } 
            `
        )
        alignFields()
        return () => {
            removeCSSClass(`landing-card-${props.section.id}`)
        }
    },[])
       
    useEffect(()=> {
        alignFields()
    }, [ composition ]) 
 
    
    return <div className={`pe-html-container landing-content-container`} data-type={data.type} data-content-id={data.id}>
        <div className={`landing-cards landing-cards-${props.section.id} ${ data.className || "" } `} >
            {
                data.cards.map((card: ICard, i: number) =>  { 
                    return <HAccordeonCard
                        key={ card.id }
                        data={ { ...card, i:i } }
                        width={ 100 }
                        contentData={ data }
                        section={ props.section }
                        isOpen={ i === current.get() }
                        setOpen={ () => current.set(i) }
                    />
                })
            } 
        </div>
        <DataContentEditor data={data}  section={props.section}  />
    </div>
}

export default CardHaccordeon